import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../../context/WalletContext';
import { useContract } from '../../context/ContractContext';
import PageContainer from '../../components/layout/PageContainer/PageContainer';
import { formatNumber, formatRelativeTime, formatUserId } from '../../utils/formatters';
import { ACTIVITY_TYPES } from '../../config/packages';
import './Activity.css';

const ActivityItem = ({ activity }) => {
  const activityType = ACTIVITY_TYPES[activity.type] || { name: 'Unknown', icon: '❓', color: '#64748B' };

  return (
    <div className="activity-item">
      <div className="activity-icon" style={{ backgroundColor: `${activityType.color}20`, color: activityType.color }}>
        {activityType.icon}
      </div>
      <div className="activity-info">
        <span className="activity-type">{activityType.name}</span>
        <span className="activity-from">
          {activity.type === 2 && activity.fromId > 0
            ? `From ${formatUserId(activity.fromId)}`
            : activity.type === 1 && activity.matched
              ? `Matched ${formatNumber(activity.matched, 0)} USDT`
              : activity.type === 4 && activity.investmentIndex !== null
                ? `Investment #${activity.investmentIndex + 1}`
                : 'System'}
        </span>
      </div>
      <div className="activity-details">
        <span className="activity-amount" style={{ color: activityType.color }}>
          {activity.type === 3 ? '-' : '+'}{formatNumber(activity.amount)}
        </span>
        <span className="activity-time">{formatRelativeTime(activity.timestamp)}</span>
      </div>
    </div>
  );
};

const Activity = () => {
  const navigate = useNavigate();
  const { isConnected, isInitializing } = useWallet();
  const { isRegistered, isCheckingRegistration, userId, getRecentActivities } = useContract();

  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    if (isInitializing || isCheckingRegistration) return;
    
    if (!isConnected) {
      navigate('/');
      return;
    }
    if (!isRegistered) {
      navigate('/register');
      return;
    }
  }, [isConnected, isRegistered, isInitializing, isCheckingRegistration, navigate]);

  useEffect(() => {
    const fetchActivities = async () => {
      if (!userId) return;
      
      try {
        const acts = await getRecentActivities(userId, 50);
        setActivities(acts);
      } catch (err) {
        console.error('Error fetching activities:', err);
      }
      setLoading(false);
    };

    fetchActivities();
  }, [userId]);

  const filteredActivities = filter === 'all' 
    ? activities 
    : activities.filter(a => a.type === parseInt(filter));

  const filters = [
    { value: 'all', label: 'All' },
    { value: '1', label: 'Binary' },
    { value: '2', label: 'Referral' },
    { value: '3', label: 'Withdraw' },
    { value: '4', label: 'ROI' }
  ];

  return (
    <PageContainer title="Activity">
      <div className="activity-page">
        <div className="activity-filters">
          {filters.map((f) => (
            <button
              key={f.value}
              className={`filter-btn ${filter === f.value ? 'active' : ''}`}
              onClick={() => setFilter(f.value)}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="activity-list">
          {loading ? (
            <div className="activity-loading">Loading activities...</div>
          ) : filteredActivities.length === 0 ? (
            <div className="activity-empty">
              <span className="empty-icon">📭</span>
              <p>No activities found</p>
            </div>
          ) : (
            filteredActivities.map((activity, idx) => (
              <ActivityItem key={idx} activity={activity} />
            ))
          )}
        </div>
      </div>
    </PageContainer>
  );
};

export default Activity;